<!--  Newsletter Hero Section -->
<div class="annual-hero-bg">
    <section class="annual-hero-section container">
        <div class="glass-panel-container">
            <div class="row align-items-center">
                <div class="col-lg-5 hero-content-col">
                    <h1 class="banner-heading-one">Newsletter</h1>
                    <nav aria-label="breadcrumb" class="breadcrumb-nav">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <a (click)="goHome()">Home</a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Newsletter</li>
                        </ol>
                    </nav>
                </div>
                <div class="col-lg-7 hero-image-col">
                    <img src="../../../../assets/newsletter/newsletter-bannerimage.png" alt="Newsletter Illustration"
                        class="hero-image">
                </div>
            </div>
        </div>
    </section>
</div>
<!-- Newsletter List Section -->
<div class="newsletters-list-section">
    <div class="container">
        <h2 class="section-title">Explore Our Newsletters</h2>

        <div class="row g-4">
            <div class="col-lg-4 col-md-6" *ngFor="let newsletter of newsletters">
                <div class="newsletter-card h-100" (click)="newsletter.clickMethod()">
                    <div class="card-image-wrapper">
                        <img [src]="newsletter.imagePath" [alt]="newsletter.month" class="card-image">
                    </div>
                    <div class="card-content">
                        <div class="info-wrapper">
                            <h6 class="card-title">{{ newsletter.month }}</h6>
                            <div class="card-meta">
                                <i class="ri-calendar-line"></i> Posted on {{ newsletter.postedOn }}
                            </div>
                        </div>
                        <div class="arrow-icon-wrapper">
                            <i class="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>